import { toast } from "react-toastify";
import { Tooltip } from "lib";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Typography, Chip } from "@mui/material";
import { Helmet } from "react-helmet";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { PageLayout, CustomTable } from "lib";
import { EventsAPI } from "api_inbusiness";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import styles from "./Tickets.module.scss";
import ConfirmModal from "lib/components/Modals/ConfirmModal";
import Search from "lib/components/Search/Search";

export const TicketsTable = ({ eventId }) => {
  const navigate = useHistory();

  const [rowData, setRowData] = useState({});
  const [openConfirm, setOpenConfirm] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [triggerRefetch, setTriggerRefetch] = useState(false);
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState("");

  const labels = [
    {
      id: "serial",
      label: "Seria",
      minWidth: 10,
    },
    {
      id: "number",
      label: "Număr",
      minWidth: 10,
    },
    {
      id: "isVip",
      label: "VIP",
      minWidth: 10,
    },
    {
      id: "fullName",
      label: "Nume Complet",
      minWidth: 10,
    },
    {
      id: "company",
      label: "Companie",
      minWidth: 10,
    },
    {
      id: "email",
      label: "Email",
      minWidth: 10,
    },

    {
      id: "valid",
      label: "Valid",
      minWidth: 10,
    },
    {
      id: "scanned",
      label: "Scanat",
      minWidth: 10,
    },

    {
      id: "reason",
      label: "Motiv invalidare",
      minWidth: 10,
    },
    {
      id: "actions",
      label: "",
      minWidth: 10,
    },
  ];

  const cellModifier = (row, column, value) => {
    if (column.id === "isVip") {
      return (
        <Chip
          label={row.isVip ? "VIP" : "Standard"}
          size="small"
          sx={{
            backgroundColor: row.isVip ? "#eab308" : "#f1f5f9",
            color: row.isVip ? "#ffffff" : "#64748b",
            fontWeight: row.isVip ? 700 : 500,
            fontSize: "12px",
            border: row.isVip ? "1px solid #ca8a04" : "1px solid #cbd5e1",
          }}
        />
      );
    }

    if (column.id === "company") {
      return (
        <Typography variant="tableContent">{row.purchase?.company || "-"}</Typography>
      );
    }

    if (column.id === "email") {
      return (
        <Typography variant="tableContent">{row.purchase?.email || "-"}</Typography>
      );
    }
    if (column.id === "scanned") {
      return (
        <Chip
          label={row.scanned === true ? "Da" : "Nu"}
          sx={{
            backgroundColor: row.scanned === true ? "green" : "red",
            color: "white",
          }}
        />
      );
    }

    if (column.id === "valid") {
      return (
        <Typography variant="tableContent">
          {row.valid === true ? "Da" : "Nu"}
        </Typography>
      );
    }

    if (column.id === "actions") {
      return (
        <div className={styles.actionArea}>
          <Tooltip position="right" textTip={"Detalii bilet"} followCursor>
            <div
              className={styles.seeDetailsButton}
              onClick={() => navigate.push(`/tickets/${row.id}`)}
            >
              <ArrowForwardIosIcon fontSize="small" />
            </div>
          </Tooltip>

          <Tooltip position="right" textTip={"Scanează manual"} followCursor>
            <div
              className={styles.scanButton}
              onClick={() => {
                setRowData(row);
                setOpenConfirm(true);
              }}
            >
              <DocumentScannerIcon fontSize="small" />
            </div>
          </Tooltip>
        </div>
      );
    }
    return <Typography variant="tableContent">{value}</Typography>;
  };

  const manualScanTicket = (ticketId) => {
    EventsAPI.manualScanTicket(ticketId).then((res) => {
      if (res.ok === true) {
        toast.success("Biletul a fost scanat cu succes");
        setOpenConfirm(false);
        setTriggerRefetch(!triggerRefetch);
        setRowData({});
      } else {
        toast.error("A intervenit o eroare");
      }
    });
  };

  return (
    <>
      <Helmet>
        <title>InBusiness CRM :: Bilete</title>
      </Helmet>
      <PageLayout
        title="Bilete"
        actionArea={
          <>
            <Search
              isSearch={isSearch}
              setIsSearch={setIsSearch}
              search={search}
              setSearch={setSearch}
              nameToFind={"Caută bilet"}
              triggerRefetch={triggerRefetch}
              setTriggerRefetch={setTriggerRefetch}
              triggerSearch={triggerSearch}
              setTriggerSearch={setTriggerSearch}
              setLoading={setLoading}
              setterFunction={setTickets}
            />
          </>
        }
      >
        <CustomTable
          labels={labels}
          loading={loading}
          setLoading={setLoading}
          tableData={tickets}
          cellModifier={cellModifier}
          getterFunction={EventsAPI.getEventTickets}
          additionalId={eventId}
          setterFunction={setTickets}
          withPagination={true}
          triggerRefetch={triggerRefetch}
          searchFunction={(text) =>
            EventsAPI.searchTicketsByEventId(eventId, text)
          }
          triggerSearch={triggerSearch}
          search={search}
          isSearch={isSearch}
          rowSx={(row) =>
            row.isVip
              ? {
                  backgroundColor: "#FEF3C7 !important",
                  "&:hover": {
                    backgroundColor: "#FDE68A !important",
                  },
                }
              : undefined
          }
        />
      </PageLayout>

      <ConfirmModal
        text={"Sunteți sigur că doriți să scanați acest bilet?"}
        buttonYes={"DA"}
        buttonNo={"NU"}
        onClickButtonYes={() => manualScanTicket(rowData.id)}
        open={openConfirm}
        setOpen={setOpenConfirm}
      />
    </>
  );
};
